import BaseService from './BaseService';

// Generic client for the dashboard settings store (any feature, any namespace).
// Mirrors src/settings in sbly-dash-collector. Feature-specific defaults/clamps are
// enforced on the backend where the setting is consumed — this just reads/writes.
class SettingsService extends BaseService {
  async get(namespace: string) {
    await this._getAccessToken();

    return this.handleHttpRequest<Record<string, unknown>>(
      () => this.http.get(`settings/${namespace}`),
      `Failed to load settings for ${namespace}`,
    );
  }

  async update(namespace: string, patch: Record<string, unknown>) {
    await this._getAccessToken();

    return this.handleHttpRequest<Record<string, unknown>>(
      () => this.http.put(`settings/${namespace}`, patch),
      `Failed to save settings for ${namespace}`,
    );
  }

  // Throwing variants for callers where a swallowed failure is worse than an
  // error: a null read looks like "no settings yet" (and seeds defaults over
  // real data), a null write looks like a successful save. get/update stay
  // as-is — other pages rely on the null contract.
  async getOrThrow(namespace: string): Promise<Record<string, unknown>> {
    await this._getAccessToken();

    const resp = await this.http.get(`settings/${namespace}`);
    return resp.data as Record<string, unknown>;
  }

  async updateOrThrow(namespace: string, patch: Record<string, unknown>): Promise<Record<string, unknown>> {
    await this._getAccessToken();

    const resp = await this.http.put(`settings/${namespace}`, patch);
    return resp.data as Record<string, unknown>;
  }
}

export default SettingsService;
